import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import PropTypes from 'prop-types'
import {CircularProgress, createFilterOptions} from '@mui/material'
import {
  StyledAutoComplete,
  StyledCheckBox,
  StyledLoaderBox,
  StyledMenuItem,
  StyledNoOptionsTextBox,
  StyledTextField
} from './Styles'
import theme from '../../../themes'
import {formatGivingCapacity} from '../../../helper/commonHelper'

const CustomSearchableDropdown = ({
  onChange,
  value,
  options = [],
  disabled = false,
  loading = false,
  isMultiSelect = false,
  placeholder = loading ? 'Loading...' : 'Start typing',
  fieldName = '',
  disableClearable = false,
  sx = {}
}) => {
  return (
    <StyledAutoComplete
      disableClearable={disableClearable}
      size="sm"
      sx={sx}
      multiple={isMultiSelect}
      limitTags={10}
      options={options}
      loading={loading}
      disabled={disabled}
      loadingText={
        <StyledLoaderBox>
          <CircularProgress size="20px" />
        </StyledLoaderBox>
      }
      filterOptions={createFilterOptions({
        matchFrom: 'any',
        limit: 100
      })}
      disableCloseOnSelect={isMultiSelect}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) =>
        fieldName === 'givingCapacity' ? formatGivingCapacity(option.name) : option.name?.toString() || ''
      }
      noOptionsText={<StyledNoOptionsTextBox>No data available</StyledNoOptionsTextBox>}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            style: {border: `1px solid ${theme.palette.common.lightBlue}`}
          }}
        />
      )}
      renderOption={(props, option, {selected}) =>
        isMultiSelect ? (
          <StyledMenuItem {...props} isMultiSelect={isMultiSelect}>
            <StyledCheckBox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={selected}
            />
            {fieldName === 'givingCapacity' ? formatGivingCapacity(option.name) : option.name}
          </StyledMenuItem>
        ) : (
          <StyledMenuItem {...props} isMultiSelect={isMultiSelect}>
            {option.name}
          </StyledMenuItem>
        )
      }
      onChange={(event, values) => {
        onChange(values)
      }}
      value={value}
    />
  )
}

CustomSearchableDropdown.propTypes = {
  loading: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  fieldName: PropTypes.string,
  disableClearable: PropTypes.bool,
  sx: PropTypes.object
}

export default CustomSearchableDropdown
